import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { FormattedHTMLMessage, injectIntl } from 'react-intl'
import styles from './richtextarea.styl'
import { RichTextEditor } from 'components/richtext'
import { FieldError } from 'components/fields'
import { get } from 'lodash'

@injectIntl
class RichTextArea extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    intlKey: PropTypes.string,
    intl: PropTypes.object,
    intlKeyPlaceholder: PropTypes.string,
    required: PropTypes.bool,
    isInitialized: PropTypes.bool
  }

  static defaultProps = {
    disabled: false,
    isInitialized: false
  }

    renderRichTextEditor = field => {
      const value = get(field, 'input.value')

      const input = get(field, 'input')

    return (<RichTextEditor value={value} input={input} isInitialized={this.props.isInitialized}></RichTextEditor>)
  }

  renderField = field => {
    const {
      disabled,
      required,
      intlKeyPlaceholder,
      placeholder,
      intl
    } = this.props
    const { meta, input } = field
    const disabledClass = disabled ? styles.disabled : ''
    const errorClass = meta.touched && meta.error ? 'has-error' : ''
    const translatedPlaceholder = intlKeyPlaceholder
      ? intl.formatMessage({
          id: intlKeyPlaceholder,
          defaultMessage: placeholder
        })
      : placeholder

    return (
      <div className={`${errorClass}`}>
        <Field
          className={`form-control ${styles.formControlTextarea} ${disabledClass}`}
          {...input}
          type='text'
          rows="5"
          disabled={disabled}
          placeholder={translatedPlaceholder}
          required={required}
          component={this.renderRichTextEditor}
        />
        <FieldError toShow={meta.touched && meta.error} message={meta.error} />
      </div>
    )
  }

  render() {
    const { label, name, intlKey } = this.props

    return (
      <div className="form-group">
        <label htmlFor={name} className="control-label">
          {intlKey
            ? <FormattedHTMLMessage id={intlKey} defaultMessage={label} />
            : label}
        </label>
        <Field id={name} name={name} component={this.renderField} />
      </div>
    )
  }
}

export default RichTextArea

